import { render, staticRenderFns } from "./PerpetratorInfo.vue?vue&type=template&id=6bc8a22f&scoped=true&"
import script from "./PerpetratorInfo.vue?vue&type=script&lang=ts&"
export * from "./PerpetratorInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc8a22f",
  null
  
)

export default component.exports